document.onkeydown = checkKey;
var imgContainer = document.getElementsByClassName("product-thumbnails")[0]
function getCount(parent, getChildrensChildren){
    var relevantChildren = 0;
    var children = parent.childNodes.length;
    for(var i=0; i < children; i++){
        if(parent.childNodes[i].nodeType != 3){
            if(getChildrensChildren)
                relevantChildren += getCount(parent.childNodes[i],true);
            relevantChildren++;
        }
    }
    return relevantChildren;
}
function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
var imgCount = getCount(imgContainer, false);
imgCount = imgCount - 1;
function swapImg(dir){
  var target;
  var current = parseInt(document.getElementsByClassName("active")[0].firstElementChild.id.split('-')[1]);
  if(dir == "F"){
    if(current == imgCount){
      target = document.getElementById("ProductImg-0");
    } else {
      target = document.getElementById("ProductImg-" + (current + 1));
    }
    
  } else {
    if(current == 0){
      target = document.getElementById("ProductImg-" + imgCount);
    } else {
      target = document.getElementById("ProductImg-" + (current - 1));
    }
    
  }
  eventFire(target, 'click');
}


document.addEventListener('touchstart', handleTouchStart, false);        
document.addEventListener('touchmove', handleTouchMove, false);
document.addEventListener('touchend', handleTouchEnd, false);

var xDown = null;                                                      
var yDown = null;
var xDiff = null;
var yDiff = null;


function getTouches(evt) {
  return evt.touches ||             // browser API
         evt.originalEvent.touches; // jQuery
}                                                     

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];   
    xDiff = null;
    yDiff = null;
    xDown = firstTouch.clientX;                           
    yDown = firstTouch.clientY;
};

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    xDiff = xDown - xUp;
    yDiff = yDown - yUp;
};

function handleTouchEnd(){
  var imageDiv = $('.product-main-image');
  //if(imageDiv.hasClass('fullscreen-image-div')){
  	if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
      console.log(xDiff);
      if ( xDiff > 75 ) {
        swapImg("F"); 
      }
      if (xDiff < -75) {
        swapImg();
      }                      
    }
 // }
    /* reset values */
    xDown = null;
    yDown = null;  
}

function toggleFullscreen(){
  	var imageDiv = $('.product-main-image');
  	if(imageDiv.hasClass('fullscreen-image-div')){
     imageDiv.removeClass('fullscreen-image-div');
	} else {
  		imageDiv.addClass('fullscreen-image-div');
    }
}
document.getElementsByClassName("fullscreen-button")[0].addEventListener("click", toggleFullscreen());
document.getElementsByClassName("next")[0].addEventListener("click", swapImg("F"));
document.getElementsByClassName("previous")[0].addEventListener("click", swapImg());


function checkKey(e) {

    e = e || window.event;
	var imageDiv = $('.product-main-image');
  	if(imageDiv.hasClass('fullscreen-image-div')){
      if (e.keyCode == '37') {
         swapImg();
      }
      else if (e.keyCode == '39') {
         swapImg("F");
      }
      else if (e.keyCode == '27') {
         toggleFullscreen();
      }
    }
} 